import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const svipHomepage = createAsyncThunk(
  '/live/svip/homepage',
  async (_arg, store: any) => {
    const resp = await http.post<HiyaRes<SvipHomepageData>>(
      '/live/svip/homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

/** 单条权益（特权 / 装饰） */
export interface SvipPower {
  id: number // 权益 id
  sub_type: number // 子类型（0大勋章、1小勋章、2头像框、3进场拖尾...13房间防被踢）
  title: string // 标题
  icon: string // 图标
  desc: string // 描述（点击权益详情弹窗时使用）
  image: string // 特权介绍图（可能是动图）
  scheme: string // 跳转链接（为空表示无跳转）
}

export interface SvipUserInfo {
  name: string // 昵称
  avatar: string // 头像
  level: number // 当前等级（0 表示未开通）
  points: number // 当前用户剩余积分
  mid: number // 用户 ID
  next_level: number // 下一个等级
  next_open_points: number // 下一个等级开通所需积分
  is_max_level: boolean // 是否已达到最高等级
  valid_until_time: number //  SVIP 有效期截止时间戳（秒）
}

export interface SvipLevelData {
  level: number
  open_points: number // 开通/升级所需累计积分
  keep_points: number // 保级所需积分
}

export interface SvipHomepageData {
  err_msg?: string // 错误信息
  privilege_map?: any // 特权权益列表，key 为等级
  decoration_map?: any
  user_info?: SvipUserInfo // 个人卡片信息
  level_list?: SvipLevelData[] // 各等级信息，从小到大
}

export type InitialStateType = SvipHomepageData

/** 初始状态为空结构，完全依赖接口返回数据填充 */
const initialState: InitialStateType = {
  err_msg: '',
  privilege_map: {},
  decoration_map: {},
  level_list: [],
}

export const SvipSlice = createSlice({
  name: 'SvipSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(svipHomepage.fulfilled, (state, action) => {
      const payload = action.payload || {}
      Object.assign(state, {
        ...payload,
        privilege_map: payload.privilege_map ?? {},
        decoration_map: payload.decoration_map ?? {},
        level_list: payload.level_list ?? [],
      })
    })
  },
})

export default SvipSlice.reducer
export const SvipActions = SvipSlice.actions

export const useSvipState = () => {
  return useSelector((state: {Svip: InitialStateType}) => state.Svip)
}
